/** Centralized data-testids (kebab-case). */
export { HOME } from "./home";
export { LOGIN, REGISTER, LOGOUT } from "./auth";
export { TIDS_P2 } from "./p2";
export { TIDS_P2B } from "./p2b";

export const TIDS = {
    // landing / public
    landingHero: "landing-hero",
    landingStaffCta: "landing-staff-cta",
    landingInmateCta: "landing-inmate-cta",

    // staff login
    staffLoginForm: "staff-login-form",
    staffLoginEmail: "staff-login-email",
    staffLoginPassword: "staff-login-password",
    staffLoginSubmit: "staff-login-submit",
    staffLoginError: "staff-login-error",

    // claim-access
    claimForm: "claim-access-form",
    claimCode: "claim-access-code",
    claimInmateNumber: "claim-access-inmate-number",
    claimDob: "claim-access-dob",
    claimSubmit: "claim-access-submit",
    claimError: "claim-access-error",

    // inmate nav / layout
    inmateNavHome: "inmate-nav-home",
    inmateNavMood: "inmate-nav-mood",
    inmateNavJournal: "inmate-nav-journal",
    inmateNavChat: "inmate-nav-chat",
    inmateNavCrisis: "inmate-nav-crisis",
    inmateLogout: "inmate-logout",

    // inmate dashboard
    inmateDashboard: "inmate-dashboard",

    // mood
    moodPage: "mood-page",
    moodSelector: (mood) => `mood-selector-${mood}`,
    moodNote: "mood-note",
    moodTagInput: "mood-tag-input",
    moodSubmit: "mood-submit",

    // journal
    journalPage: "journal-page",
    journalNewBtn: "journal-new-btn",
    journalTitle: "journal-title",
    journalContent: "journal-content",
    journalMood: (m) => `journal-mood-${m}`,
    journalSubmit: "journal-submit",
    journalAiCoach: "journal-ai-coach",
    journalList: "journal-list",

    // chat
    chatPage: "chat-page",
    chatInput: "chat-input",
    chatSubmit: "chat-submit",
    chatMessages: "chat-messages",

    // crisis (inmate)
    crisisPage: "crisis-page",
    crisisNeedHelpBtn: "crisis-need-help-btn",
    crisisConfirmBtn: "crisis-confirm-btn",
    crisisConfirmed: "crisis-confirmed",

    // institution
    instNavDashboard: "inst-nav-dashboard",
    instNavCodes: "inst-nav-codes",
    instNavCrisis: "inst-nav-crisis",
    instNavInmates: "inst-nav-inmates",
    instLogout: "inst-logout",
    instDashboard: "inst-dashboard",
    instActiveBanner: "inst-active-banner",
    instGenerateCodeBtn: "inst-generate-code-btn",
    instBulkCount: "inst-bulk-count",
    instBulkGenerateBtn: "inst-bulk-generate-btn",
    instCodesTable: "inst-codes-table",
    instCrisisList: "inst-crisis-list",
    instAckBtn: (id) => `inst-ack-btn-${id}`,
    instResolveBtn: (id) => `inst-resolve-btn-${id}`,
    instInterventionBtn: (id) => `inst-intervention-btn-${id}`,

    // Phase 2B — Staff side
    instNavMetrics: "inst-nav-metrics",
    instNavPreRelease: "inst-nav-pre-release",
    instNavMedicaid: "inst-nav-medicaid",
    instNavBulkEnroll: "inst-nav-bulk-enroll",

    inmateDetailPage: "inmate-detail-page",
    inmateRiskBadge: "inmate-risk-badge",
    inmateRecalcRisk: "inmate-recalc-risk",
    inmateCrisisHistory: "inmate-crisis-history",
    inmateAssessmentCard: "inmate-assessment-card",
    inmateRnraCard: "inmate-rnra-card",
    inmatePhq9Card: "inmate-phq9-card",

    metricsPage: "metrics-page",
    metricsRange: "metrics-range",
    metricsHeadline: "metrics-headline",
    metricsRiskDist: "metrics-risk-distribution",
    metricsTrendChart: "metrics-trend-chart",
    metricsMoodChart: "metrics-mood-chart",

    preReleasePage: "pre-release-page",
    preReleaseRow: (id) => `pre-release-row-${id}`,
    preReleaseToggle: (id, key) => `pre-release-toggle-${id}-${key}`,
    preReleaseProgress: (id) => `pre-release-progress-${id}`,

    medicaidPage: "medicaid-page",
    medicaidRow: (id) => `medicaid-row-${id}`,
    medicaidStatusSelect: (id) => `medicaid-status-select-${id}`,
    medicaidSaveBtn: (id) => `medicaid-save-btn-${id}`,

    bulkEnrollPage: "bulk-enroll-page",
    bulkEnrollFile: "bulk-enroll-file",
    bulkEnrollPreview: "bulk-enroll-preview",
    bulkEnrollCommit: "bulk-enroll-commit",
    bulkEnrollResult: "bulk-enroll-result",
};
